var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 47,
    viewBox: "0 0 41 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3289 46.9731C20.3289 46.9731 0 40.9667 0 11.3419V0H40.6648V11.3419C40.6648 39.9074 20.3289 46.9731 20.3289 46.9731Z",
    fill: "#4FB84F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6648 2.78949V11.3419C40.6648 39.9074 20.7361 47.1262 20.3289 46.9864C19.9217 46.8466 19.519 46.6945 19.1209 46.5303C18.723 46.3661 18.33 46.1898 17.9427 46.0017C17.5551 45.814 17.1736 45.6141 16.7983 45.4031C16.4231 45.1921 16.0543 44.9696 15.6923 44.7363V32.3156H23.4795C30.7535 32.3023 32.0687 28.4535 32.0687 23.6838V20.8418H15.6923V11.4276H32.0687C38.5536 11.3419 40.6648 7.56556 40.6648 2.78949Z",
    fill: "#045433"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.0ec033a12ed4a112d9376a48e8471bd8.svg";
export { ForwardRef as ReactComponent };